<template>
  <div class="profile">
    <div class="header">
      <div class="title">Profile</div>
    </div>
    <div class="body">
      <div class="title">Profile Photo</div>
      <div class="content">
        <div class="info-container">
          <div class="profile-picture">
            <template v-if="myProfilePictureUrl">
              <img v-bind:src="myProfilePictureUrl" v-on:click="onClickChangePhoto()" ontouchstart="" class="text-btn">
            </template>
            <template v-else>
              <comp-icon
              v-bind:icon="'person'"
              v-bind:width="100" v-on:click="onClickChangePhoto()" ontouchstart="" class="text-btn"></comp-icon>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div
    v-if="!isIPAuth"
    class="body">
      <div class="title">Full Name</div>
      <div class="content">
        <div class="info-container" v-on:click="onClickChangeName()" ontouchstart="">
          <div class="text-btn">
            {{myName}}
          </div>
        </div>
      </div>
    </div>
    <div
    v-if="isIPAuth"
    class="body">
      <div class="title">IP User</div>
      <div class="content">
        <div class="info-container">{{ipAuthIP}}</div>
        <div class="info-container">
          {{myName}}
        </div>
        <div class="info-container">
          <div
          v-on:click="onClickChangeIPUserName()" ontouchstart=""
          class="text-btn">Change name</div>
        </div>
      </div>
    </div>
    <div
    v-if="!isIPAuth"
    class="body">
      <div class="title">Email Address</div>
      <div class="content">
        <div class="info-container">
          <div v-on:click="onClickChangeEmail()" ontouchstart=""
          class="text-btn">{{myEmail}}</div>
        </div>
      </div>
    </div>
    <div
    v-if="!isIPAuth"
    class="body">
      <div class="title">Password</div>
      <div class="content">
        <div class="info-container">
          <div v-on:click="onClickChangePassword()" ontouchstart=""
            class="text-btn">
            <div class="password">********************</div> 
          </div>
        </div>
      </div>
    </div>
    <div
    v-if="hasMyDealer"
    class="body">
      <div class="title">My dealer</div>
      <div class="content">
        <div class="info-container">
          <div style="font-weight:bold">{{myDealer.dealerName}}</div>
          <div class="vertical-center" style="flex-wrap:wrap;">
            <span class="badge blue">{{myDealerType}}</span>
            <span class="badge blue">Owner: {{myDealer.ownerInfo.email}}</span>
          </div>
          <div class="description">{{myDealer.locationInfo.address}}</div>
          <div class="description">{{myDealer.contactInfo.email}} / {{myDealer.contactInfo.phone}}</div>
        </div>
        <div
        v-if="iAmOwnerOfMyDealer"
        class="info-container">
          <div
          v-on:click="onClickChangeDealerInfo()" ontouchstart=""
          class="text-btn">Change registration information</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import CompIcon from '@/components/CompIcon'
export default {
  name: 'profile',
  components: {
    CompIcon
  },
  computed: {
    myProfilePictureUrl: function () {
      return this.$store.getters.myProfilePictureUrl
    },
    myName: function () {
      return this.$store.getters.myFirstName ? this.$store.getters.myFirstName + ' ' + this.$store.getters.myLastName : ''
    },
    myEmail: function () {
      return this.$store.getters.myEmail
    },
    myDealer: function () {
      return this.$store.getters.myDealer
    },
    myDealerType: function () {
      return this.$store.getters.myDealerType
    },
    hasMyDealer: function () {
      return this.$store.getters.hasMyDealer
    },
    myDealerHasPendingRegistration: function () {
      return this.$store.getters.myDealerHasPendingRegistration
    },
    iAmOwnerOfMyDealer: function () {
      return this.$store.getters.iAmOwnerOfMyDealer
    },
    isIPAuth: function (state) {
      return !!this.$store.getters.idTokenIPAuthDealerID
    },
    ipAuthIP: function (state) {
      return this.$store.getters.idTokenIPAuthIP
    }
  },
  data: function () {
    return {
      email: 'trevor.seo@chekt.com',
      name: 'Trevor S. Seo',
      camera: null
    }
  },
  methods: {
    onClickChangePhoto: function () {
      this.$emit('openChangePhotoModal')
    },
    onClickChangePassword: function () {
      this.$emit('openChangePasswordModal')
    },
    onClickChangeDealerInfo: function () {
      this.$emit('openChangeDealerInfoModal')
    },
    onClickChangeName: function () {
      this.$emit('openChangeNameModal')
    },
    onClickChangeIPUserName: function () {
      this.$emit('openChangeIPUserNameModal')
    },
    onClickChangeEmail: function () {
      this.$emit('openChangeEmailModal')
    },
    onClickChangeProfile: function () {
      if (!this.camera) {
        console.log('this.initJpegCamera()')
        this.initJpegCamera()
      } else {
        console.log('this.stopJpegCamera()')
        this.stopJpegCamera()
      }
    },
    initJpegCamera: function () {
      let options = {
        quality: 0.5,
        shutter: false,
        mirror: false,
        timeout: 0,
        retry_success: false,
        scale: 0.4
      }
      this.camera = new this.$jpegCamera(this.$refs.webcam, options).ready((info) => {
        console.log(info)
      })
    },
    stopJpegCamera: function () {
      this.camera.stop_stream()
      this.$refs.webcam.innerHTML = ''
      this.camera = null
    }
  }
}
</script>

<style scoped>

.profile {
  /* common */
  color: var(--gray-high);
  /* size */
  max-width: 700px;
  width: 100%;
  height: 100%;
}

.profile .header {
  /* common */
  font-size: 14px;
  /* size */
  padding: 20px 16px 40px;
  /* text */
  font-weight: bold;
  /* alignment */
  text-align: left;
}
.profile .header .title {
  /* common */
  font-size: 3em;
  
}
.profile .header .description {
  /* common */
  font-size: 2em;
}


.profile .body {
  /* size */
  padding: 8px 16px;
  /* border */
  border-top: 1px solid #dedede;
  /* alignment */
  text-align: left;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
}

.profile .body .title {
  /* common */
  color: var(--gray-high);
  font-size: 16px;
  /* size */
  margin: 16px 0;
  /* text */
  font-weight: bold;
  /* size */
  width: 200px;
}

.profile .body .content {
  /* common */
  color: var(--gray-high);
  font-size: 16px;
  /* size */
  min-width: 240px;
  width: calc(100% - 200px);
  min-height: 3em;
  margin: 16px 0;
  /* border */
  /* outline: 1px solid red; */
}
.profile .body .content.row {
  /* alignment */
  text-align: left;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
}

.profile .body .content .info-container:first-child {
  margin-top: 0;
}
.profile .body .content .info-container {
  /* size */
  margin: 1em 0;
  line-height: 1.5rem;
}
.profile .body .content .info-container .description{
  color: var(--gray-low);
  font-size: 14px;
}
.profile .body .content .info-container > input {
  /* common */
  background-color: #fefefe;
  /* size */
  width: calc(100% - 1em);
  padding: 0.5em;
}

.profile .body .content .info-container .password {
  /* common */
  background-color: #dedede;
  color: transparent;
  display: inline;
  border-radius: 4px;
}

.profile .body .content .info-container .profile-picture {
  /* common */
  background-color: #fefefe;
  color: #000;
  overflow: hidden;
  /* size */
  width: 100px;
  height: 100px;
  /* alignment */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
}

.profile .body .content .info-container .profile-picture > img {
  /* size */
  width: 100%;
  height: 100%;
  /* position */
  position: relative;
  z-index: 1;
}
.profile .body .content .info-container .text-btn {
  transition: 0.2s ease all;
  width: fit-content;
}
.profile .body .content .info-container .text-btn:hover {
  /* common */
  opacity: 0.5;
  /* mouse */
  cursor: pointer;
  /* alignment */
  display: inline;
}


.profile .body .content .action-btns {
  /* size */
  margin: 1em 0 2em;
  /* alignment */
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.profile .body .content .action-btn {
  /* common */
  background-color: hsla(0, 0%, 80%, 1);
  color: #000;
  white-space: nowrap;
  /* size */
  padding: 0.5em 1em;
  margin-right: 1em;
  margin-top: 1em;
  /* mouse */
  cursor: pointer;
}
.profile .body .content .action-btn.blue {
  /* common */
  background-color: var(--primary);;
  color: #fefefe;
}


.profile .badge {
  /* common */
  border-radius: 4px;
  /* text */
  font-size: 14px;
  font-weight: bold;
  /* size */
  padding: 1em;
  padding: 0 0.5em;
  /* position */
  margin: 4px 4px 0 0;
}
.profile .badge.blue {
  /* common */
  color: #fefefe;
  background-color: var(--primary);;
}

</style>



// WEBPACK FOOTER //
// src/pages/Account/Profile.vue